import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';
import APIErrorMascot from 'components/Mascot/APIErrorMascot';
import TaskForm from 'containers/JobsTasks/shared/TaskForm';
import { useFetchTaskById } from 'hooks/task/useFetchTaskById';

import { initialTaskFormData } from '../shared/TaskForm/schema';

const EditTask: React.FC<unknown> = () => {
  const [formData, setFormData] = useState<typeof initialTaskFormData>(initialTaskFormData);

  const { id } = useParams();

  const { data, status } = useFetchTaskById(id!);

  useEffect(() => {
    if (status === 'success') {
      const fetchedFormData = data?.payload;

      const formData: typeof initialTaskFormData = {
        ...initialTaskFormData,
        billable: fetchedFormData.billable ? ['1'] : [],
        billable_rate: fetchedFormData.billable_rate ?? 0,
        id: fetchedFormData.id,
        name: fetchedFormData.name,
        description: fetchedFormData.description || '',
        jobs: fetchedFormData.assigned_jobs || [],
      };

      setFormData(formData);
    }
  }, [status, data]);

  if (status === 'loading') return <LogoLoader />;
  if (status === 'error') return <APIErrorMascot />;

  return <TaskForm formData={formData} />;
};

export default EditTask;
